// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07044f67","453":"df1b56a3","455":"62349211"}[chunkId] + ".chunk.js";
};